import { render } from "./Detalhes.vue?vue&type=template&id=65610828"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"

import "./Detalhes.vue?vue&type=style&index=0&id=65610828&lang=scss"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__